import { Kb3dModel } from '../decorators/kb3d-decorator';
import { eSketchPathType } from '../enums';
import { SketchControlPoint } from '../features/sketch-control-point';
import { ISketchPath } from '../kb3d-models';
import { Kb3dObject } from '../kb3d-object';
import { IKbVectorLike } from '../primitives';
import { Token } from '../token';
import { SketchNode } from './sketch-node';

@Kb3dModel({
    token: Token.SketchPath,
})
export class SketchPath extends Kb3dObject implements ISketchPath {
    /** Next target path connected to this one. Full paths are built linked-list style */
    toIndex: number;
    /** Path control points */
    controlPoints: SketchControlPoint[] = [];
    /** How smooth to make this path when rasterizing to geometry */
    tessellation = 16;
    /** Type of arc to use for this path */
    type: eSketchPathType;

    /** For grouping paths as one contiguous shape. Only required for hole-path matching */
    pathGroupKey = 'default';

    /** Whether to treat this path as part of a hole for extrusions and fills */
    holeForPathGroup: string;

    _expanded = false;
    _points: IKbVectorLike[] = [];

    /** override base parent for more specific typing*/
    public _parent: SketchNode | undefined;

    public getChildren(): Kb3dObject[] {
        return super.getChildren().concat(this.controlPoints);
    }

    public getChildArrayForType(token: Token): Kb3dObject[] | undefined {
        if (token.isConnector()) {
            return this.controlPoints;
        } else {
            return super.getChildArrayForType(token);
        }
    }

    public getAncestors() {
        return super.getAncestors() as SketchNode[];
    }
}
